<template>
  <div class="baseSetting">
    <div class="content-container">
      <div class="titieMian">
        <div class="title-container">基地设置</div>
        <div class="select-container">
          <div class="select-container-box">
            <span>基地&nbsp;&nbsp;</span>
            <el-select
              v-model="fishBaseFilterId"
              filterable
              placeholder="请选择"
              size="small"
            >
              <el-option
                v-for="(item, index) in fishBaseOptions"
                :key="index"
                :label="item.value || '全部'"
                :value="item.key"
              >
              </el-option>
            </el-select>
          </div>
          <div class="select-container-box">
            <span>在&nbsp;&nbsp;</span>
            <el-select
              v-model="base"
              filterable
              placeholder="请选择"
              size="small"
            >
              <el-option
                v-for="(item, index) in baseList"
                :key="index"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="select-container-box">
            <span>查找&nbsp;&nbsp;</span>
            <el-input
              placeholder="请输入关键字"
              v-model="keyword"
              prefix-icon="el-icon-search"
              size="small"
              type="text"
              :maxlength="20"
              onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
              class="search-input"
              clearable
            >
            </el-input>
          </div>
          <div class="select-container-box" v-if="(canEditAll = true)">
            <el-button
              size="small"
              type="info"
              plain
              @click="goSearch(1)"
              class="query"
              >查询</el-button
            >
            <el-button
              size="small"
              type="info"
              plain
              @click="goAdd"
              class="add"
              v-if="edit"
              >增加</el-button
            >
          </div>
        </div>
      </div>
      <div class="table-container">
        <el-table
          :data="list"
          @row-dblclick="dataBackFillGoods"
          style="width: 100%"
          size="medium"
          :default-sort="{ prop: 'date', order: 'descending' }"
        >
          <i slot="empty" style="font-style: normal">暂无数据</i>
          <el-table-column
            prop="date"
            label="日期"
            :formatter="formatter"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="fishBaseName"
            label="基地名称"
            align="center"
            width="200"
            show-overflow-tooltip
            :filters="getFilterList"
            :filter-method="filterHandler"
          >
          </el-table-column>
          <el-table-column prop="fishPondCount" label="塘口数量" align="center">
          </el-table-column>
          <el-table-column prop="fishPondArea" label="塘口面积" align="center">
          </el-table-column>
          <!-- <el-table-column
            prop="fish"
            label="主养品种"
            align="center"
            :filters="getFilterFishList"
            :filter-method="filterHandler"
          >
          </el-table-column> -->
          <el-table-column prop="leader" label="基地负责人" align="center">
          </el-table-column>
          <el-table-column
            prop="phone"
            align="center"
            label="联系方式"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="address"
            label="基地地址"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column label="操作栏" align="center" width="200">
            <template slot-scope="scope">
              <span
                @click="baseSettingEdit(scope.$index, scope.row)"
                class="content-edit"
                >{{ edit ? "编辑" : "查看" }}</span
              >
              <span
                @click="baseSettingDelete(scope.$index, scope.row)"
                class="content-del"
                v-if="edit"
                >删除</span
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <page-change :pageInfo="pageInfo"></page-change>
      <!-- 弹窗 -->
      <div v-if="dialogFormVisible">
        <el-dialog
          :title="titleName"
          :visible.sync="dialogFormVisible"
          width="766px"
        >
          <el-form
            :model="baseForms"
            :rules="rules"
            ref="baseForms"
            class="baseForm"
          >
            <el-form-item
              label="基地名称"
              prop="name"
              :label-width="formLabelWidth"
            >
              <el-input
                v-model="baseForms.name"
                :disabled="!edit"
                placeholder="请输入基地名称"
                onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
                :maxlength="num20"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="基地负责人"
              prop="leaderId"
              :label-width="formLabelWidth"
            >
              <el-select
                v-model="baseForms.leaderId"
                filterable
                placeholder="请选择负责人"
                @change="getPhone"
                :disabled="!edit"
              >
                <el-option
                  v-for="item in companyUser"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="联系电话"
              prop="phone"
              :label-width="formLabelWidth"
            >
              <el-input
                v-model.number="baseForms.phone"
                disabled
                :maxlength="num11"
                placeholder="请输入联系电话"
                onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
              ></el-input>
            </el-form-item>
            <el-row>
              <el-form-item label="主养品种" required>
                <el-col :span="9">
                  <el-form-item prop="fishCategoryId">
                    <el-select
                      class="fishCate"
                      v-model="fishCategoryList"
                      placeholder="请选择鱼分类名称"
                      size="medium"
                      style="width: 100%"
                      @change="changeFishGetCategory"
                    >
                      <el-option
                        v-for="item in fishGetCategory"
                        :key="item.key"
                        :label="item.value"
                        :value="item"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col
                  :span="9"
                  v-if="fishCategoryList"
                  style="margin-left: -17px"
                >
                  <el-form-item prop="fishName">
                    <el-select
                      class="fishCate"
                      v-model="baseForms.fishName"
                      filterable
                      :disabled="!edit"
                      @change="getFishName"
                      placeholder="请选择鱼种类型"
                    >
                      <el-option
                        v-for="item in fishGetCategoryName"
                        :key="item.key"
                        :label="item.value"
                        :value="item"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item
                label="基地地址"
                required
                :label-width="formLabelWidth"
              >
                <el-col :span="7">
                  <el-form-item prop="provinceNo">
                    <el-select
                      v-model="baseForms.provinceNo"
                      filterable
                      class="address"
                      placeholder="请选择省份"
                      @change="selectProvince"
                      :disabled="!edit"
                    >
                      <el-option
                        v-for="item in provinces"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="7">
                  <el-form-item prop="cityNo" v-if="citys.length > 0">
                    <el-select
                      v-model="baseForms.cityNo"
                      filterable
                      class="address"
                      placeholder="请选择市"
                      @change="selectCity"
                      :disabled="!edit"
                    >
                      <el-option
                        v-for="item in citys"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="7">
                  <el-form-item prop="countyNo" v-if="countys.length > 0">
                    <el-select
                      v-model="baseForms.countyNo"
                      filterable
                      class="address"
                      placeholder="请选择县"
                    >
                      <el-option
                        v-for="item in countys"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                        :disabled="!edit"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-form-item>
            </el-row>
            <el-form-item
              label="详细地址"
              prop="detail"
              :label-width="formLabelWidth"
            >
              <el-input
                v-model="baseForms.detail"
                type="text"
                :maxlength="num30"
                :disabled="!edit"
                placeholder="请输入详细地址"
                onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="塘口数量"
              prop="pondCount"
              :label-width="formLabelWidth"
            >
              <el-input
                v-model="baseForms.pondCount"
                type="text"
                :maxlength="num30"
                :disabled="!edit"
                placeholder="请输入塘口数量"
                onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
                onkeyup="value=value.replace(/[^\d\s.]/g,'')"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="塘口面积"
              prop="pondArea"
              :label-width="formLabelWidth"
            >
              <el-input
                v-model="baseForms.pondArea"
                type="text"
                :maxlength="num30"
                :disabled="!edit"
                placeholder="请输入塘口面积"
                onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
                onkeyup="value=value.replace(/[^\d\s.]/g,'')"
              ></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer" v-if="edit">
            <el-button @click="cancel('baseForms')">取 消</el-button>
            <el-button
              type="primary"
              @click="save('baseForms')"
              v-if="this.titleName === '添加基地信息'"
              >保 存</el-button
            >
            <el-button
              type="primary"
              @click="saveEdit('baseForms')"
              v-if="this.titleName === '编辑基地信息'"
              >保 存</el-button
            >
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
function objSortASCII(obj) {
  var arr = new Array();
  var num = 0;
  for (var i in obj) {
    arr[num] = i;
    num++;
  }
  var sortArr = arr.sort();
  var sortObj = {};
  for (var i in sortArr) {
    sortObj[sortArr[i]] = obj[sortArr[i]];
  }
  return sortObj;
}
function addQueryString(params) {
  var str = '';
  for (var Key in params) {
    if(params[Key] !== null){
      str += Key + '=' + params[Key] + '&';
    }
  }
  return str;
}
import md5 from 'js-md5';
import PageChange from "../../../common/PageChange";
import { mapActions, mapState } from "vuex";
import { modules } from "../../../../store";
import checkPermission from "../../../../service/checkPermission.js";
import mixins from "@/common/MixIn.js";
import { resolveFishBaseKeyFromList, fishBaseIdForQuery } from "@/common/resolveFishBaseSelection.js";
export default {
  name: "baseSetting",
  mixins: [mixins],
  components: {
    PageChange
  },
  data() {
    return {
      fishCategoryList: "", // 鱼分类选择监听列表
      fishNameList: "", // 鱼分类下名称监听列表
      formLabelWidth: "100px",
      titleName: "",
      dialogFormVisible: false,
      num20: 20,
      num11: 11,
      num30: 30,
      companyUser: [], //负责人
      citys: [],
      countys: [],
      baseForms: {
        name: "",
        leaderId: "", // 联系人
        phone: "",
        provinceNo: "", // 省份
        cityNo: "", // 城市
        countyNo: "", // 辖区
        detail: "", // 详细地址
        pondCount: "",
        pondArea: "",
        fishCategoryId: "", // 鱼分类名称
        fishCategoryName: "",
        fishId: "", // 鱼分类ID
        fishName: "" // 鱼分类名称
      },
      rules: {
        name: [
          {
            required: true,
            message: "请先输入基地名称",
            trigger: "blur"
          },
          // {
          //   pattern: /^[a-zA-Z0-9_\u4e00-\u9fa5]+$/,
          //   message: "基地名称格式不对,请重新输入"
          // }
        ],
        leaderId: [
          { required: true, message: "请先选择负责人", trigger: "change" }
        ],
        phone: [{ required: true, message: "请先填写联系电话" }],
        provinceNo: [
          { required: true, message: "请先选择省份", trigger: "change" }
        ],
        cityNo: [{ required: true, message: "请先选择市", trigger: "change" }],
        countyNo: [
          { required: true, message: "请先选择县", trigger: "change" }
        ],
        fishCategoryId: [
          { required: true, message: "请选择鱼分类名称", trigger: "change" }
        ],
        fishId: [
          { required: true, message: "请选择鱼种名称", trigger: "change" }
        ],
        detail: [
          { required: true, message: "请先输入详细地址", trigger: "blur" }
          // {
          //   pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+$/,
          //   message: "详细地址格式不对,请重新输入",
          //   min: 2
          // }
        ]
      },
      fishBaseFilterId: "",
      fishBaseOptions: [],
      base: "",
      baseList: [
        {
          value: "",
          label: "全部"
        },
        {
          value: "name",
          label: "基地名称"
        },
        {
          value: "leader",
          label: "负责人"
        }
      ],
      list: [],
      keyword: "", // 关键字
      pageInfo: {
        pageNumber: 1, // 当前页数
        totalPages: 0, // 总页数
        pageFunc: this.goSearch, // 当前页数需要调用的函数
        pageSize: 10 // 当前页数
      },
      rowId: "" // 编辑的id
    };
  },
  methods: {
    ...mapActions(modules.base, [
      "getBaseSettingList",
      "deleteBaseSetting",
      "addBaseSetting",
      "changeBaseSetting",
      "getChangeBaseSetting",
      "getAllBaseList"
    ]),
    ...mapActions(modules.user, ["getEmployees"]),
    ...mapActions(modules.area, {
      getProvinces: "getProvinces",
      getArea: "getArea"
    }),
    ...mapActions(modules.fish, [
      "getFishGetCategory", // 获取渔种信息
      "getFishGetCategoryName" // 获取分类渔种名称
    ]),
    //分类渔种---
    async changeFishGetCategory(val) {
      this.baseForms.fishCategoryName = val.value;
      this.baseForms.fishCategoryId = val.key;
      let res = await this.getFishGetCategoryName(
        this.baseForms.fishCategoryId
      );
      if (res.status == 200) {
        this.fishNameList = "";
        this.baseForms.fishName = "";
        this.baseForms.fishId = "";
      }
    },
    async getFishName(val) {
      this.baseForms.fishName = val.value;
      this.baseForms.fishId = val.key;
    },
    //获取鱼分类下得鱼种
    //获取鱼分类
    getFishNameData() {
      this.getFishGetCategory()
        .then(rsp => {
          console.log(rsp);
        })
        .catch(err => {
          console.dir(err);
        });
    },
    //双击进入编辑页面
    async dataBackFillGoods(row, event) {
      this.dialogFormVisible = true;
      if (this.edit) {
        this.titleName = "编辑基地信息";
      } else {
        this.titleName = "查看基地信息";
      }
      this.getProvinces();
      this.companyUser = await this.getEmployees(); //获取负责人
      let result = await this.getChangeBaseSetting(row.id);
      this.baseForms.name = result.name;

      this.baseForms.detail = result.address;
      this.baseForms.phone = result.phone;
      this.baseForms.provinceNo = result.provinceId;
      await this.selectProvince();
      this.baseForms.cityNo = result.cityId;
      await this.selectCity();
      this.baseForms.countyNo = result.countyId;
      console.log(111, result.leaderId);
      this.baseForms.pondCount = result.pondCount;
      this.baseForms.pondArea = result.pondArea;
      //this.baseForms.leaderId = result.leaderId;
      this.$set(this.baseForms, "leaderId", result.leaderId);
      console.log(9991, this.baseForms.leaderId);

      this.rowId = row.id;
      this.fishCategoryList = this.fishGetCategory.find(item => item.key === result.fishCategoryId)
      await this.changeFishGetCategory(this.fishCategoryList)

      this.baseForms.fishName = this.fishGetCategoryName.find(item => item.key === result.fishId)
      this.getFishName(this.baseForms.fishName)
    },
    //查询所有数据
    async goSearch(pageNum) {
      const pageIndex = pageNum || 1;
      this.pageInfo.pageNumber = pageIndex;
      let obj = {
        pageIndex,
        pageSize: this.pageInfo.pageSize,
        name: this.name,
        leader: this.leader,
        address: this.adress
      };
      const pick =
        this.fishBaseFilterId !== "" && this.fishBaseFilterId != null
          ? this.fishBaseOptions.find(
              (f) =>
                f.key === this.fishBaseFilterId ||
                String(f.key) === String(this.fishBaseFilterId)
            )
          : null;
      if (pick && pick.key !== "" && pick.key != null) {
        obj.name = pick.value;
        if (this.base === "leader" && this.keyword) {
          obj.leader = this.keyword;
        }
        if (this.base === "address" && this.keyword) {
          obj.address = this.keyword;
        }
      } else {
        if (this.base !== "") {
          obj[this.base] = this.keyword;
        } else {
          obj.name = this.keyword;
          obj.leader = this.keyword;
          obj.address = this.keyword;
        }
      }
      try {
        let result = await this.getBaseSettingList(obj);
        this.pageInfo.totalPages = result.total;
        this.list = result.list;
      } catch (error) {
        this.$message.error(error.response.data);
      }
    },
    // 格式化指定列时间
    formatter(row) {
      if (!row.date) {
        return false;
      }
      return this.$timeformatDay(row.date);
    },
    // 筛选过滤
    filterHandler(value, row, column) {
      const property = column["property"];
      return row[property] === value;
    },
    //获取联系方式
    getPhone(e) {
      console.log(2, e);

      this.baseForms.leaderId = e;
      this.baseForms.phone = Number(
        this.companyUser.find(f => f.id == e).phone
      );
    },
    //省份获取之后 获取对应的城市
    async selectProvince() {
      let obj = {
        parentNo: this.baseForms.provinceNo
      };
      let result = await this.getArea(obj);
      this.citys = result;
      this.baseForms.cityNo = null;
      this.baseForms.countyNo = null;
      this.countys = [];
    },
    // 城市获取之后 获取对应的县市
    async selectCity() {
      let obj = {
        parentNo: this.baseForms.cityNo
      };
      let result = await this.getArea(obj);
      this.countys = result;
      this.baseForms.countyNo = null;
    },
    // 添加--基地
    async goAdd() {
      this.dialogFormVisible = true;
      this.fishCategoryList = "";
      this.baseForms = {
        name: "",
        leaderId: "", // 联系人
        phone: "",
        provinceNo: "", // 省份
        cityNo: "", // 城市
        countyNo: "", // 辖区
        detail: "", // 详细地址
        pondCount: "",
        pondArea: "",
        fishCategoryId: "", // 鱼分类名称
        fishCategoryName: "",
        fishId: "", // 鱼分类ID
        fishName: "" // 鱼分类名称
      };
      let addressNo = JSON.parse(localStorage.getItem('cacheAddressNo'))
      if(addressNo){
        this.baseForms.provinceNo = addressNo.provinceNo
        await this.selectProvince()
        this.baseForms.cityNo = addressNo.cityNo
        await this.selectCity()
        this.baseForms.countyNo = addressNo.countyNo
      }
      this.titleName = "添加基地信息";
      this.getProvinces();
      this.companyUser = await this.getEmployees(); //获取负责人
    },
    //取消
    cancel(formName) {
      this.$refs[formName].resetFields();
      this.dialogFormVisible = false;
      this.baseForms = {
        name: "",
        leaderId: "", // 联系人
        phone: "",
        provinceNo: "", // 省份
        cityNo: "", // 城市
        countyNo: "", // 辖区
        detail: "", // 详细地址
        pondCount: "",
        pondArea: "",
        fishCategoryId: "",
        fishCategoryName: "",
        fishId: "",
        fishName: ""
      };
    },
    //保存
    save(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if(!this.baseForms.fishId){
             this.$message({
               message: "请选择主养品种",
               type: "error"
             });
             return;
          }
          let obj = {
            name: this.baseForms.name,
            leaderId: this.baseForms.leaderId,
            areaId:
              this.baseForms.countyNo ||
              this.baseForms.cityNo ||
              this.baseForms.provinceNo,
            detail: this.baseForms.detail,
            pondCount:
              this.baseForms.pondCount === "" ? 0 : this.baseForms.pondCount,
            pondArea:
              this.baseForms.pondArea === "" ? 0 : this.baseForms.pondArea,
            fishCategoryId: this.baseForms.fishCategoryId,
            fishCategoryName: this.baseForms.fishCategoryName,
            fishId: this.baseForms.fishId,
            fishName: this.baseForms.fishName
          };
          this.addBaseSetting(obj)
            .then(rsp => {
              if (rsp.status === 200) {
                localStorage.setItem("cacheAddressNo", JSON.stringify({
                  provinceNo: this.baseForms.provinceNo,
                  cityNo: this.baseForms.cityNo,
                  countyNo: this.baseForms.countyNo,
                }));
                this.$message({
                  message: "保存成功",
                  type: "success"
                });
                this.dialogFormVisible = false;
                this.goSearch();
                this.baseForms = {
                  name: "",
                  leaderId: "", // 联系人
                  phone: "",
                  provinceNo: "", // 省份
                  cityNo: "", // 城市
                  countyNo: "", // 辖区
                  detail: "", // 详细地址
                  pondCount: "",
                  pondArea: "",
                  fishCategoryId: "",
                  fishCategoryName: "",
                  fishId: "",
                  fishName: ""
                };
                this.$refs[formName].resetFields();
              }
            })
            .catch(err => {
              this.$Alert.info({
                content: err.response.data,
                duration: 5000,
                status: "error"
              });
              // this.$message.error(err.response.data);
            });
        } else {
          return false;
        }
      });
    },
    //获取当前行数据
    async baseSettingEdit(index, row) {
      this.dialogFormVisible = true;
      if (this.edit) {
        this.titleName = "编辑基地信息";
      } else {
        this.titleName = "查看基地信息";
      }
      this.getProvinces();
      this.companyUser = await this.getEmployees(); //获取负责人
      let result = await this.getChangeBaseSetting(row.id);
      this.baseForms.name = result.name;

      this.baseForms.detail = result.address;
      this.baseForms.phone = result.phone;
      this.baseForms.provinceNo = result.provinceId;
      await this.selectProvince();
      this.baseForms.cityNo = result.cityId;
      await this.selectCity();
      this.baseForms.countyNo = result.countyId;
      this.baseForms.pondCount = result.pondCount;
      this.baseForms.pondArea = result.pondArea;
      this.baseForms.fishCategoryId = result.fishCategoryId;
      this.baseForms.fishCategoryName = result.fishCategoryName;
      this.baseForms.fishId = result.fishId;
      this.baseForms.fishName = result.fishName;
      console.log(111, result.leaderId);

      //this.baseForms.leaderId = result.leaderId;
      this.$set(this.baseForms, "leaderId", result.leaderId);
      console.log(9991, this.baseForms.leaderId);
      this.rowId = row.id;

      this.fishCategoryList = this.fishGetCategory.find(item => item.key === result.fishCategoryId)
      await this.changeFishGetCategory(this.fishCategoryList)

      this.baseForms.fishName = this.fishGetCategoryName.find(item => item.key === result.fishId)
      this.getFishName(this.baseForms.fishName)
    },
    //更新
    saveEdit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let obj = {
            id: this.rowId,
            name: this.baseForms.name,
            leaderId: this.baseForms.leaderId,
            areaId:
              this.baseForms.countyNo ||
              this.baseForms.cityNo ||
              this.baseForms.provinceNo,
            detail: this.baseForms.detail,
            pondCount:
              this.baseForms.pondCount === "" ? 0 : this.baseForms.pondCount,
            pondArea:
              this.baseForms.pondArea === "" ? 0 : this.baseForms.pondArea,
            fishCategoryId: this.baseForms.fishCategoryId,
            fishCategoryName: this.baseForms.fishCategoryName,
            fishId: this.baseForms.fishId,
            fishName: this.baseForms.fishName
          };
          const sortObj = objSortASCII(obj)
          const str = addQueryString(sortObj) + 'SecretKey=RsMKL0XS7BifcKOWRxzhqZ0JNO6vzAXyXdLufl5WlUO0CnYuR07CCWw1LD4Iq9us'
          console.log(str);
          console.log(str.toLowerCase());
          console.log(md5(str.toLowerCase()));
          this.changeBaseSetting({obj, md5: md5(str.toLowerCase())})
            .then(rsp => {
              if (rsp.status === 200) {
                this.$message({
                  message: "保存成功",
                  type: "success"
                });
                this.baseForms = {
                  name: "",
                  leader: "", // 联系人
                  phone: "",
                  provinceNo: "", // 省份
                  cityNo: "", // 城市
                  countyNo: "", // 辖区
                  detail: "", // 详细地址
                  pondCount: "",
                  pondArea: "",
                  fishCategoryId: "",
                  fishCategoryName: "",
                  fishId: "",
                  fishName: ""
                };
                this.dialogFormVisible = false;
                this.goSearch(Number(localStorage.getItem("pageNumber")));
                this.$refs[formName].resetFields();
              }
            })
            .catch(err => {
              this.$Alert.info({
                content: err.response.data,
                duration: 5000,
                status: "error"
              });
              // this.$message.error(err.response.data);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //删除
    baseSettingDelete(index, row) {
      this.$confirm("此操作将永久删除该记录，是否继续？", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          this.rowId = row.id;
          this.deleteBaseSetting(this.rowId)
            .then(rsp => {
              if (rsp.status === 200) {
                this.$message({
                  message: "删除成功",
                  type: "success"
                });
                this.goSearch();
              }
            })
            .catch(err => {
              this.$Alert.info({
                content: err.response.data,
                duration: 5000,
                status: "error"
              });
            });
        })
        .catch(err => {
          this.$message.error(err.response.data);
          console.dir(err);
        });
    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
    //通过负责人筛选联系方式
  },
  computed: {
    ...mapState(modules.area, {
      provinces: "provinces"
    }),
    ...mapState(modules.fish, ["fishGetCategory", "fishGetCategoryName"]),
    getFilterList() {
      // 过滤筛选数据
      const res = new Map();
      let fiterList = this.list
        .map(m => ({
          value: m.fishBaseName,
          text: m.fishBaseName
        }))
        .filter(a => !res.has(a.text) && res.set(a.text, 1));
      return fiterList;
    },
    getFilterFishList() {
      const res = new Map();
      let fiterList = this.list
        .map(m => ({
          value: m.fish,
          text: m.fish
        }))
        .filter(a => !res.has(a.text) && res.set(a.text, 1));
      return fiterList;
    }
  },
  mounted() {
    console.log(mixins, this.curCompany, 111);
    this.getFishNameData(); //渔种名称
    this.getAllBaseList({ forQueryAll: true }).then((list) => {
      this.fishBaseOptions = list || [];
      this.fishBaseFilterId = resolveFishBaseKeyFromList(
        this.fishBaseOptions,
        this.fishBaseFilterId
      );
      this.goSearch(1);
    });
  }
};
</script>
<style lang="stylus">
.baseSetting {
  .el-dialog {
    height: 670px;
    border-radius: 6px;

    .el-dialog__header {
      border-radius: 6px 6px 0px 0px;
      padding: 16px 20px 16px;
      background: linear-gradient(270deg, rgba(51, 137, 255, 1), rgba(31, 156, 244, 1), rgba(49, 170, 255, 1));

      .el-dialog__title {
        color: #fff;
      }
    }

    .el-input {
      width: 500px;
    }

    .el-input__inner {
      width: 500px;
      margin-left: 10px;
    }

    .el-form-item__content {
      z-index: 999999;
      line-height: 40px;
      position: relative;
      // font-size: 24px;
    }

    .el-form .el-form-item .el-form-item__label {
      margin-left: 65px;
      width: 100px;
      font-size: 16px;
      text-align: right;
    }

    .ruleForm {
      margin-left: 0px;
    }

    .el-dialog__close {
      color: #fff;
    }

    .el-dialog__footer {
      position: relative;
      bottom: 12px;
      padding: 0px 0px 0px 0px;
      margin-right: 351px;
    }

    .el-button--primary {
      margin-left: 20px;
      background: #3389ff;
    }

    .el-button {
      width: 100px;
      height: 40px;
    }

    .el-button--default {
      margin-left: 117px;
    }

    .el-form-item .el-form-item__label:before {
      position: absolute;
      top: 2px;
      left: -12px;
      color: #fe3223;
    }

    .el-form-item__error {
      padding-top: 2px;
      position: absolute;
      top: 100%;
      left: 74px;
    }

    .el-icon-date {
      position: relative;
    }

    .el-icon-date:before {
      content: '\E608';
      position: absolute;
      left: 13px;
      top: 3px;
    }

    .el-select.address .el-input {
      width: 160px !important;
    }

    .el-select.address .el-input__inner {
      width: 160px !important;
    }

    .el-select.fishCate .el-input {
      width: 245px !important;
    }

    .el-select.fishCate .el-input__inner {
      width: 245px !important;
    }

    .el-col-7 {
      width: 26.34%;
    }
  }
}
</style>
